import React, { useCallback } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import { FiFile } from 'react-icons/fi'

import Yup from '../../../../../services/yup'
import { api, authHeaders } from '../../../../../services/api'

import { downloadRelatorioJasper } from '../../../../../util/file'

import { Button, Calendar } from '../../../../../components/Form'
import Spinner from '../../../../../components/Spinner'

import { Container, ButtonContainer } from './styles'

import rangeDayGif from '../../../../../assets/images/gifs/periodo-dias.gif'
import rangeMonthGif from '../../../../../assets/images/gifs/periodo-mes.gif'

const initialValues = {
    pagamento: '',
    competencia: ''
}

const validation = Yup.object().shape({
    competencia: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    pagamento: Yup.string().nullable()
})

const nomeRelatorio = 'Relatório Resumo de Mensalidades'

export default function (props) {
    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const {
            competencia,
            pagamento
        } = values

        const inicio = pagamento ? pagamento[0] : null
        const fim = pagamento ? pagamento[1] : null
        const compInicio = competencia ? competencia[0] : null
        const compFim = competencia ? competencia[1] : null

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioResumoMensalidade',
                parametros: {
                    dataPagamentoInicio: inicio !== null ? format(new Date(inicio), 'yyyy-MM-dd') : '',
                    dataPagamentoFim: fim !== null ? format(new Date(fim), 'yyyy-MM-dd') : inicio !== null ? format(new Date(inicio), 'yyyy-MM-dd') : '',
                    competenciaInicio: compInicio !== null ? format(new Date(compInicio), 'yyyy-MM-dd') : '',
                    competenciaFim: compFim !== null ? format(new Date(compFim), 'yyyy-MM-dd') : (compInicio !== null) ? format(new Date(compInicio), 'yyyy-MM-dd') : ''
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch (e) {
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, resetForm
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Calendar
                            name="competencia"
                            dateFormat="mm/yy"
                            view="month"
                            label="Competência"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f1' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeMonthGif}" style="width:300px; height:auto" />`}
                        />

                        <Calendar
                            name="pagamento"
                            label="Data de Pagamento"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f2' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
